import React, {useEffect, useState} from 'react';
import {Link, useParams, useSearchParams} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";

import {Box, Card, Grid, Tab, Tabs} from "@mui/material";

import {TabContext, TabPanel} from "@mui/lab";

import {useGetStateV2TOHQuery} from "../../core/api/toh-state-api";


import RawDataEdit from "./ba/RawDataEdit";
import ChargesList from "../Charger/chargesList";
import PaymentsRT from "../Payments/rt";
import Loading from "../../components/Common/Loading";
import RtConsumables from "../Consumables/rt";
import TechInfoRT from "../TechInfo/techInfoRT";
import RTLocationsTable from "./rt/RTLocationsTable";
import InGameListRT from "../InGame/InGameListRT";
import OffersListRT from "./rt/OffersListRT";
import {stringify, parse} from "lossless-json";
import {isEmpty} from "../../core/utils/StringUtils";
import {getDeviceIdAbsentWarning} from "../../core/utils/constants";
import ListJson from "./ListJson";
import CitiesTable from "./toh/CitiesTable";
import {selectGuidMapToh, useGetGuidMapTohQuery} from "../../core/api/toh-charge-api";
import SimBuildings from "./toh/SimBuildings";


function UserStatesToh(props) {

    const {action, tab: tabParam, subtab: subTabParam, game} = useParams()
    const CommonData = useSelector((state) => state.data.CommonData)
    const deviceId = CommonData.deviceId;
    const stateId = CommonData.stateId;
    const deviceIdIsEmpty = isEmpty(deviceId) && isEmpty(stateId);
    const errorMessage = CommonData.errorMessage;

    const link_prefix = '/' + game + '/' + action + '/' + deviceId + '/'
    const tab = tabParam || 'update'
    const subTab = subTabParam || (tab == 'analytics' ? 'payments' : 'consumables');
    const [params] = useSearchParams();
    const vendorIdParam = params.get('vendorId');
    let paramString = `?vendorId=${vendorIdParam}`

    const state = useSelector((state) => state.data.SolitaierState)

    //const state = useState()
    const dispatch = useDispatch();

    const {
        data: obj,
        isLoading,
        isSuccess,
        isError,
        error,
        status: objStatus
    } = useGetStateV2TOHQuery({deviceId, stateId})


    const [tabIndex, setTabIndex] = useState(tab);
    const [subTabIndex, setSubTabIndex] = useState(subTab);

    const handleTabChange = (event, newTabIndex) => {
        setTabIndex(newTabIndex);
        setSubTabIndex(newTabIndex == 'analytics' ? 'payments' : 'consumables');
    };


    const handleSubTabChange = (event, newTabIndex) => {
        setSubTabIndex(newTabIndex);
    };


    useEffect(() => {

    }, [deviceId, dispatch]);

    let status = ""

    let content = ""
    let panel1 = ""
    let panel2 = ""

    let charges = ""

    const {
        data: guidMap,
    } = useGetGuidMapTohQuery()

    const addGuidNames = (list) => {
        guidMap.GlobalItemAll.forEach(({ guid, name }) => {
            if(list.hasOwnProperty(guid)) {
                list[guid]['name'] = name
            }
        });
        return list
    };
    const getBinaryFlags = (n) => {
        let binaryString = n.toString(2);
        return binaryString;
    }
    const addHeroGuidNames = (list) => {
        if(!guidMap?.hasOwnProperty('Hero')) return list

        guidMap.Hero.forEach(({ guid, name }) => {
            if(list.hasOwnProperty(guid)) {
                list[guid]['name'] = name
            }
        });

        Object.keys(list).forEach((key) => {
            try {
                list[key].Slots = getBinaryFlags(list[key].Slots) + ' ('+list[key].Slots+')'
            } catch (e) {
                list[key].Slots = JSON.stringify(list[key].Slots)
            }
        })

        return list

    };

    let isRaw = false
    let jsonData = null
    let data = {}

    if (typeof obj === "object" && obj.hasOwnProperty('data') && objStatus === 'fulfilled') {
        //const data = obj.data
        try {
            const raw = parse(atob(obj.value))
            data = JSON.parse(atob(obj.value))
            jsonData = raw

            if (data.hasOwnProperty('Records'))
                panel2 = <RTLocationsTable locations={data.Records.LocationProfile}/>


        } catch (e) {
            isRaw = true
            jsonData = obj.data
        }

        content = <TabContext value={tabIndex}>
            <Card>
                <Tabs value={tabIndex} onChange={handleTabChange}>
                    <Tab label="Update" value="update" component={Link} to={link_prefix + "update" + paramString}/>
                    <Tab label="heroes" value="heroes" component={Link} to={link_prefix + "heroes" + paramString}/>
                    <Tab label="cities" value="cities" component={Link} to={link_prefix + "cities" + paramString}/>
                    <Tab label="items" value="items" component={Link} to={link_prefix + "items" + paramString}/>
                </Tabs>
            </Card>

            <TabPanel value="analytics">
                <TabContext value={subTabIndex}>
                    <Box className={"subtabs"}>
                        <Tabs value={subTabIndex} onChange={handleSubTabChange}>

                            <Tab label="TechInfo" value="techinfo" component={Link}
                                 to={link_prefix + "analytics/techinfo" + paramString}/>
                            <Tab label="Payments" value="payments" component={Link}
                                 to={link_prefix + "analytics/payments" + paramString}/>
                            <Tab label="Balance items" value="balanceitems" component={Link}
                                 to={link_prefix + "analytics/balanceitems" + paramString}/>

                        </Tabs>


                        <TabPanel value="balanceitems">
                            <RtConsumables deviceId={deviceId}/>
                        </TabPanel>
                        <TabPanel value="payments">
                            <PaymentsRT deviceId={deviceId}/>
                        </TabPanel>
                        <TabPanel value="techinfo">
                            <TechInfoRT deviceId={deviceId}/>
                        </TabPanel>

                    </Box>
                </TabContext>
            </TabPanel>



            <TabPanel value="charges">
                <Card>
                    <ChargesList deviceId={deviceId}/>
                </Card>
            </TabPanel>

            <TabPanel value="locations">
                <Card>
                    {panel2}
                </Card>
            </TabPanel>

            <TabPanel value="update">

                <RawDataEdit data={jsonData} isRaw={isRaw} raw={jsonData} ></RawDataEdit>
            </TabPanel>

            <TabPanel value="heroes">
                <Grid size={8}>
                    <Card>
                        {data.hasOwnProperty("Heroes") && <ListJson items={addHeroGuidNames(data?.Heroes?.Unlocked)} fields={['name','Level','Grade','Rank','Hidden','Slots']} />}
                    </Card>
                </Grid>
            </TabPanel>
            <TabPanel value="cities">
                <Grid size={8}>
                        {data.hasOwnProperty("Cities") && <CitiesTable cities={data?.Cities} />}
                </Grid>
            </TabPanel>
            <TabPanel value="items">
                <Grid size={8}>
                    <Card>
                        {guidMap!=undefined && data.hasOwnProperty("Items") && <ListJson items={addGuidNames(data?.Items?.Items)} fields={['name','CityId','InfiniteTimeEnd','Count']} />}
                    </Card>
                </Grid>
            </TabPanel>
            <TabPanel value="offers">
                <Grid size={8}>
                    <Card>

                        {data.hasOwnProperty("Records") && data.Records.hasOwnProperty("OfferProfile") &&
                            <OffersListRT items={data?.Records?.OfferProfile.Offers}/>
                        }
                    </Card>
                </Grid>
            </TabPanel>
            <TabPanel value="decor">
                <Grid size={8}>
                    <Card>

                        {(data.hasOwnProperty("Records") && data.Records.hasOwnProperty('DecorProfile')) &&
                            <InGameListRT items={data.Records.DecorProfile.Items.Consumables}/>
                        }
                    </Card>
                </Grid>
            </TabPanel>
        </TabContext>

    }

    return (
        <>
            <Loading isError={isError} isLoading={isLoading} error={error}>
                <div>{status}</div>
                <div>{content}</div>
            </Loading>


        </>
    );

}

export default UserStatesToh
